/**
 * Represent a resource with either an ID string, or an object with an `id`.
 */
export type ResourceIdentifier = string | { id: string };
export const resourceId = (identifier: ResourceIdentifier): string => (
	typeof(identifier) === "string" ? identifier : identifier.id
);
